export default "__VITE_ASSET__CY6XDK4K__"